import { VStack } from "@gluestack-ui/themed";
import { SelectTransactionsList } from "@repo/core/components/core/SelectTransactionsList";
import { CancelTransactionController } from "./controller";
// import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { Button } from "@repo/core/components/core/Button";
import { AuthorizationModal } from "./components/AuthorizationModal";
import { AlertModal } from "@repo/core/components/layout/ModalTemplate/AlertModal";
import { AlertModalVariant } from "@repo/core/components/layout/ModalTemplate/AlertModal/types";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const CancelTransaction = () => {
  const {
    isMobile,
    selectedTransaction,
    handleOnChange,
    handleOnSubmitForm,
    isValid,
    // control,
    transactionsOptions,
    authorizationModalRef,
    handleOnAuthorizationConfirm,
    alertModalRef,
    alertOptions,
    isFetching,
    isLoading
  } = CancelTransactionController();

  return (
    <Scaffolds.Root
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect title="Cancelar Transação">
        <Scaffolds.Form
          showHeader={false}
          px="$4"
          centerFormContent={!isFetching && transactionsOptions.length === 0}
          footerContent={
            <VStack justifyContent="flex-end" pb={isMobile ? "$4" : "$4"}>
              <Button
                isDisabled={!isValid}
                text="Confirmar cancelamento"
                onPress={handleOnSubmitForm}
              />
            </VStack>
          }
        >
          <SelectTransactionsList
            title="Transações do dia"
            isLoading={isFetching}
            date={new Date(Date.now())}
            transactions={transactionsOptions}
            selected={selectedTransaction}
            onChange={handleOnChange}
          />
        </Scaffolds.Form>
      </Scaffolds.StoreSelect>
      <AuthorizationModal
        title="Autorização"
        ref={authorizationModalRef}
        onConfirm={handleOnAuthorizationConfirm}
        onClose={authorizationModalRef?.current?.close}
        isLoading={isLoading}
      />
      <AlertModal
        ref={alertModalRef}
        title="Cancelamento realizado"
        text="A transação foi cancelada com sucesso."
        variant={AlertModalVariant.success}
        options={alertOptions}
      />
    </Scaffolds.Root>
  );
};

export default CancelTransaction;
